// Angular
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

// Classes/Data/Interface/Extra
import { accountTypes } from '../../shared/accounts';
import { allCountries } from '../../shared/countries';
import { RegisterUser } from '../../shared/classes';
import { planType } from '../../shared/data-tables'

// Services
import { MessagesService } from 'src/app/services/message/messages.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.less']
})
export class CreateUserComponent implements OnInit {
  public listOfAllAcountTypes = accountTypes;
  public listOfAllCountries = allCountries;

  public registerUserForm: FormGroup;
  public passwordString = '';
  public accountSelect = 'free'
  private isAdminSelected = false;

  constructor(private fb: FormBuilder, private msg: MessagesService, private admin: AdminService, private load: NgxSpinnerService) { }

  ngOnInit() {
    this.initForm();
    this.init();
  }

  // init
  private init() {
    // this.listOfAllAcountTypes = accountTypes.filter(account => {
    //   return account.type !== 'Suspend';
    // });

    for(let i = 0; i < accountTypes.length;i++){
        if(accountTypes[i].type == 'Suspend'){
          accountTypes.splice(i,1);
        }
        if(accountTypes[i].type == 'expired'){
          accountTypes.splice(i,1);
        }
    }
    this.listOfAllAcountTypes = accountTypes;
  }

  // init form
  private initForm() {
    this.registerUserForm = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      company: [''],
      country: ['', Validators.required],
      userId: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(5)]],
      accountType: ['', Validators.required],
      adminId: [''],
      year:[''],
      planType:['']
    });
  }

  // update account type
  public updateAccountType(accType) {
    if (accType.includes('PA')) {
      this.isAdminSelected = true;
    } else {
      this.isAdminSelected = false;
    }
      this.accountSelect = accType;
  }

  // set country
  public setCountry(country) {
    this.registerUserForm.get('country').setValue(country);
  }

  // set account type
  public setAccountType(accountType) {
    this.registerUserForm.get('accountType').setValue(accountType);
  }

  // update template password written
  public updatePasswordWritten() {
    this.passwordString = this.registerUserForm.value.password;
  }

  // creates the user
  public createUser() {
    // NgxSpinner
    this.load.show();
   
    // get form fields
    const fName = this.registerUserForm.value.firstName;
    const lName = this.registerUserForm.value.lastName;
    const comp = this.registerUserForm.value.company;
    const country = this.registerUserForm.value.country;
    const userId = this.registerUserForm.value.userId;
    const email = this.registerUserForm.value.email;
    const accType = this.registerUserForm.value.accountType;
    const password = this.registerUserForm.value.password;
    const year = this.registerUserForm.value.year;
    const plan_type = this.registerUserForm.value.planType;

    let adminId = null;
    let subscription = null;
    let type =  accType;
    let expire = new Date();
  
    if(accType.includes('PA')){
       type = "beginner"
    }
    if(accType == 'beginner' || accType == 'developer'){
      let temp = plan_type.split("_");
      if(temp[1] == 'yearly'){
        expire.setFullYear(expire.getFullYear() + Number(temp[2]));
      }
      if(temp[1] == 'monthly'){
        expire.setMonth(expire.getMonth() + Number(temp[2]));
      }
      subscription =  JSON.stringify
      ({
        account:{
          package  : type,
          activate : true,
          start_date: new Date(),
          expired_date : expire,
          plan_type : plan_type
        }
      });
    }
    else{
      if(accType != 'free'){
        expire.setFullYear(expire.getFullYear() + year);
        subscription =  JSON.stringify
        ({
          account:{
            package  : type,
            activate : true,
            start_date: new Date(),
            expired_date : expire
          }
        });
      }
    }

    // check if password empty
    if (password === '' || password === null) {
      this.msg.warn('Password is empty');
      return;
    }

    if (this.isAdminSelected) {
      adminId = userId;
    }
    
    // create the user
    const newUser = new RegisterUser(
      fName,
      adminId,
      lName,
      comp,
      country,
      email,
      password,
      accType,
      userId,
      subscription
    );
    this.admin.createTheUser(newUser)
        .then(msg => this.success(msg))
        .catch(err => this.error(err));
  }

  public getItem(item) {
    if(item === 'planType'){
      let plans = planType[this.accountSelect]
      plans = plans.filter(plan => {
          return plan != 'all';
      })
      return plans;
    }
  }


  // handle success
  private success(res) {
    this.load.hide();
    this.msg.success(res);
    this.resetField();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  // resets form field
  private resetField() {
    this.registerUserForm.reset();
  }
}
